"use client";

import { useState } from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FleetShowcase() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const [activeSedanIndex, setActiveSedanIndex] = useState(0);
  const [activeSuvIndex, setActiveSuvIndex] = useState(0);
  const fleet = [{
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/mercedes_s_class_luxury_sedan.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/mercedes_s_class_luxury_sedan.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/mercedes_s_class_luxury_sedan.png-wvc-sizes",
    title: "Mercedes-Benz S-Class",
    category: "Luxury Sedan",
    description: "The pinnacle of luxury and comfort for executive travel."
  }, {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/cadillac_escalade_executive_suv.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/cadillac_escalade_executive_suv.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/cadillac_escalade_executive_suv.png-wvc-sizes",
    title: "Cadillac Escalade",
    category: "Executive SUV",
    description: "Spacious and commanding presence for group VIP transport."
  }, {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/bmw_7_series_chauffeur.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/bmw_7_series_chauffeur.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/bmw_7_series_chauffeur.png-wvc-sizes",
    title: "BMW 7 Series",
    category: "Luxury Sedan",
    description: "Dynamic performance meets sophisticated interior design."
  }, {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/range_rover_autobiography.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/range_rover_autobiography.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/range_rover_autobiography.png-wvc-sizes",
    title: "Range Rover Autobiography",
    category: "Luxury SUV",
    description: "Unmatched versatility and refinement for any destination."
  }];
  return <section id="fleet-showcase" ref={ref} className="bg-background text-foreground section-padding relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className={`text-center mb-16 transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <span className="text-secondary font-semibold tracking-widest uppercase text-sm mb-4 block">
            Our Exclusive Fleet
          </span>
          <h2 className="text-4xl md:text-6xl font-display font-bold mb-6 text-primary-dark">
            Travel in Unrivaled Style
          </h2>
          <div className="w-24 h-1 bg-secondary mx-auto mb-8" />
          <p className="text-muted-foreground text-lg max-w-3xl mx-auto leading-relaxed">
            From executive sedans to spacious SUVs, our meticulously maintained fleet 
            is designed to provide the ultimate in comfort, privacy, and safety.
          </p>
        </div>

        <div className={`transition-all duration-[var(--duration-slow)] delay-200 ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}>
          <Carousel opts={{
          loop: true,
          align: "start"
        }} className="w-full max-w-6xl mx-auto">
            <CarouselContent className="-ml-4 md:-ml-6">
              {fleet.map((item, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:pl-6 md:basis-1/2 lg:basis-1/2">
                  <div className="group relative overflow-hidden rounded-lg shadow-medium bg-white">
                    <div className="aspect-[16/10] overflow-hidden">
                      <img src={item.image} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                    </div>
                    
                    {}
                    <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                      <div className="glass-effect p-6 border-white/20 backdrop-blur-xl bg-white/70">
                        <div className="flex justify-between items-start mb-2">
                          <div>
                            <span className="text-xs font-bold uppercase tracking-tighter text-secondary mb-1 block">
                              {item.category}
                            </span>
                            <h3 className="text-2xl font-display font-bold text-primary-dark">
                              {item.title}
                            </h3>
                          </div>
                        </div>
                        <p className="text-sm text-muted-foreground line-clamp-2 opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100">
                          {item.description}
                        </p>
                      </div>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            
            <div className="flex justify-center gap-4 mt-12">
              <CarouselPrevious className="static translate-y-0 size-12 border-2 border-primary text-primary hover:bg-primary hover:text-white transition-colors" />
              <CarouselNext className="static translate-y-0 size-12 border-2 border-primary text-primary hover:bg-primary hover:text-white transition-colors" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}